var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _path12, _path13, _rect3, _rect4, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 255,
    viewBox: "0 0 271 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.596 31.6233V135.213C249.596 135.732 249.199 136.129 248.68 136.129H143.624C143.105 136.129 142.708 135.732 142.708 135.213V2.91618C142.708 2.39701 143.105 2 143.624 2H219.973C220.217 2 220.461 2.09162 220.614 2.27486L249.321 30.9819C249.474 31.1652 249.596 31.379 249.596 31.6233Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.596 31.6233V135.213C249.596 135.732 249.199 136.129 248.68 136.129H143.624C143.105 136.129 142.708 135.732 142.708 135.213V2.91618C142.708 2.39701 143.105 2 143.624 2H219.973C220.217 2 220.461 2.09162 220.614 2.27486L249.321 30.9819C249.474 31.1652 249.596 31.379 249.596 31.6233Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.363 28.2945H154.862C152.236 28.2945 150.067 26.1567 150.067 23.4998C150.067 20.8734 152.205 18.7051 154.862 18.7051H180.363C182.989 18.7051 185.157 20.8428 185.157 23.4998C185.157 26.1567 183.019 28.2945 180.363 28.2945Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.363 28.2945H154.862C152.236 28.2945 150.067 26.1567 150.067 23.4998V23.4998C150.067 20.8734 152.205 18.7051 154.862 18.7051H180.363C182.989 18.7051 185.157 20.8428 185.157 23.4998V23.4998C185.157 26.1567 183.019 28.2945 180.363 28.2945Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.596 31.2568H221.255C220.736 31.2568 220.339 30.8598 220.339 30.3406V2L249.596 31.2568Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.596 31.2568H221.255C220.736 31.2568 220.339 30.8598 220.339 30.3406V2L249.596 31.2568Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 43.5033H241.258",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 60.3915H241.258",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 77.2494H241.258",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 94.1068H241.258",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 110.965H241.258",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.792,
    y: 106.155,
    width: 133.702,
    height: 26.722,
    transform: "rotate(-24.7147 53.792 106.155)",
    fill: "#0E9C63"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.792,
    y: 106.155,
    width: 133.702,
    height: 26.722,
    transform: "rotate(-24.7147 53.792 106.155)",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9572 134.847L32.9182 123.944C31.208 120.249 32.8266 115.882 36.5219 114.202L47.9131 108.949L59.0906 133.228L47.6993 138.481C44.0346 140.161 39.6675 138.542 37.9572 134.847Z",
    fill: "#778AEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9572 134.847L32.9182 123.944C31.208 120.249 32.8266 115.882 36.5219 114.202L47.9131 108.949L59.0906 133.228L47.6993 138.481C44.0346 140.161 39.6675 138.542 37.9572 134.847Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9141,
    y: 108.879,
    width: 6.47436,
    height: 26.722,
    transform: "rotate(-24.7147 47.9141 108.879)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9141,
    y: 108.879,
    width: 6.47436,
    height: 26.722,
    transform: "rotate(-24.7147 47.9141 108.879)",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.44 74.623L175.263 50.3442L211.147 47.5651C212.032 47.504 212.49 48.5423 211.88 49.1837L186.44 74.623Z",
    fill: "#FFE3CB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.44 74.623L175.263 50.3442L211.147 47.5651C212.032 47.504 212.49 48.5423 211.88 49.1837L186.44 74.623Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206.901 54.1922L204.092 48.1149L211.238 47.5652C212.093 47.5041 212.551 48.5119 211.971 49.1227L206.901 54.1922Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.901 54.1922L204.092 48.1149L211.238 47.5652C212.093 47.5041 212.551 48.5119 211.971 49.1227L206.901 54.1922Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06543 253.493H269.935",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7979 30.4321C47.2105 34.3717 43.2098 36.8454 45.6224 40.8155C48.035 44.7551 52.0662 42.2814 54.5094 46.221C56.922 50.1606 52.9213 52.6343 55.334 56.6044",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4539 82.2271C36.1557 78.9594 39.4845 75.6 36.1862 72.3628C32.8879 69.0951 29.5591 72.4545 26.2609 69.2173C22.9626 65.9496 26.2914 62.5902 22.9932 59.353",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09766 102.383C13.4343 100.734 15.1139 105.132 19.4505 103.483C23.7871 101.834 22.0769 97.4054 26.4135 95.7562C30.7501 94.1071 32.4298 98.5048 36.7664 96.8556",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M208.337 146.94C211.635 150.208 208.306 153.567 211.605 156.805C214.903 160.072 218.232 156.683 221.53 159.95C224.828 163.218 221.499 166.577 224.798 169.814",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M204.824 222.525C208.122 225.793 204.794 229.152 208.092 232.39C211.39 235.657 214.719 232.267 218.017 235.535C221.316 238.803 217.987 242.162 221.285 245.399",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M263.797 161.263C259.888 163.737 257.353 159.736 253.444 162.24C249.535 164.714 252.07 168.715 248.16 171.189C244.251 173.662 241.717 169.662 237.808 172.166",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M264.591 219.013C260.682 221.487 258.147 217.486 254.238 219.99C250.329 222.464 252.863 226.465 248.954 228.939C245.045 231.412 242.511 227.412 238.602 229.916",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39453 127.028C7.96765 129.96 4.97478 133.625 8.57844 136.557C12.1516 139.488 15.175 135.824 18.7481 138.786C22.3212 141.718 19.3283 145.383 22.932 148.314",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6484 180.473C21.2216 183.404 18.2287 187.069 21.8323 190.001C25.4055 192.933 28.4289 189.268 32.002 192.23C35.5751 195.162 32.5822 198.827 36.1859 201.759",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8135 179.098C98.0279 177.174 100.013 181.45 104.197 179.526C108.411 177.602 106.426 173.296 110.641 171.341C114.855 169.417 116.84 173.693 121.024 171.769",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M175.629 181.633C177.95 177.632 182.042 180.015 184.394 176.014C186.745 172.013 182.653 169.631 184.974 165.63C187.326 161.63 191.387 164.012 193.739 160.011",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89746 229.488C7.47838 230.191 6.74543 234.863 11.3264 235.596C15.9073 236.299 16.6402 231.626 21.2211 232.359C25.8021 233.061 25.0691 237.734 29.65 238.467",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9023 164.531C30.6282 161.782 33.4378 165.6 37.1636 162.851C40.8894 160.103 38.1103 156.285 41.8361 153.567C45.562 150.819 48.3716 154.636 52.0974 151.888",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8301 25.5457C95.7989 23.2553 98.1199 19.163 94.0887 16.8725C90.0575 14.582 87.7365 18.7049 83.7053 16.4144C79.6741 14.124 81.9951 10.0317 77.9639 7.74121",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137.608 10.2153C134.034 13.1777 131.011 9.51292 127.438 12.4753C123.865 15.4376 126.888 19.0718 123.315 22.0341C119.742 24.9964 116.719 21.3317 113.146 24.294",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5371 43.5034C85.5371 44.4196 84.7736 45.1831 83.8574 45.1831C82.9412 45.1831 82.1777 44.4196 82.1777 43.5034C82.1777 42.5872 82.9412 41.8237 83.8574 41.8237C84.7736 41.8237 85.5371 42.5872 85.5371 43.5034Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1718 59.292C46.1718 60.2082 45.4084 60.9716 44.4922 60.9716C43.576 60.9716 42.8125 60.2082 42.8125 59.292C42.8125 58.3758 43.576 57.6123 44.4922 57.6123C45.4084 57.6123 46.1718 58.3758 46.1718 59.292Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.44 148.192C237.44 149.109 236.677 149.872 235.761 149.872C234.845 149.872 234.081 149.109 234.081 148.192C234.081 147.276 234.845 146.513 235.761 146.513C236.677 146.513 237.44 147.246 237.44 148.192Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.591 191.895C264.591 192.811 263.827 193.574 262.911 193.574C261.995 193.574 261.231 192.811 261.231 191.895C261.231 190.978 261.995 190.215 262.911 190.215C263.827 190.215 264.591 190.948 264.591 191.895Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.91 241.704C262.91 242.62 262.147 243.384 261.23 243.384C260.314 243.384 259.551 242.62 259.551 241.704C259.551 240.788 260.314 240.024 261.23 240.024C262.147 240.024 262.91 240.757 262.91 241.704Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.299 183.19C207.299 184.107 206.535 184.87 205.619 184.87C204.703 184.87 203.939 184.107 203.939 183.19C203.939 182.274 204.703 181.511 205.619 181.511C206.566 181.511 207.299 182.244 207.299 183.19Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9463 82.2274C20.9463 83.1436 20.1828 83.9071 19.2666 83.9071C18.3504 83.9071 17.5869 83.1436 17.5869 82.2274C17.5869 81.3112 18.3504 80.5478 19.2666 80.5478C20.1828 80.5172 20.9463 81.2807 20.9463 82.2274Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.126 149.872C181.126 150.788 180.362 151.552 179.446 151.552C178.53 151.552 177.767 150.788 177.767 149.872C177.767 148.956 178.53 148.192 179.446 148.192C180.362 148.192 181.126 148.956 181.126 149.872Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9463 121.409C20.9463 122.325 20.1828 123.089 19.2666 123.089C18.3504 123.089 17.5869 122.325 17.5869 121.409C17.5869 120.493 18.3504 119.729 19.2666 119.729C20.1828 119.729 20.9463 120.493 20.9463 121.409Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3408 173.724C48.3408 174.64 47.5773 175.403 46.6611 175.403C45.7449 175.403 44.9814 174.64 44.9814 173.724C44.9814 172.807 45.7449 172.044 46.6611 172.044C47.5773 172.044 48.3408 172.807 48.3408 173.724Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3798 162.852C10.3798 163.768 9.61636 164.531 8.70018 164.531C7.78399 164.531 7.02051 163.768 7.02051 162.852C7.02051 161.935 7.78399 161.172 8.70018 161.172C9.6469 161.172 10.3798 161.905 10.3798 162.852Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5009 219.013C92.5009 219.929 91.7375 220.693 90.8213 220.693C89.9051 220.693 89.1416 219.929 89.1416 219.013C89.1416 218.097 89.9051 217.333 90.8213 217.333C91.768 217.333 92.5009 218.097 92.5009 219.013Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9541 210.676C17.9541 211.592 17.1906 212.356 16.2744 212.356C15.3582 212.356 14.5947 211.592 14.5947 210.676C14.5947 209.76 15.3582 208.997 16.2744 208.997C17.2211 208.997 17.9541 209.76 17.9541 210.676Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.144 6.0619C109.144 6.97809 108.381 7.74157 107.465 7.74157C106.549 7.74157 105.785 6.97809 105.785 6.0619C105.785 5.14572 106.549 4.38223 107.465 4.38223C108.381 4.35169 109.144 5.11518 109.144 6.0619Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4241 233.978L42.9043 253.493H72.2833L57.0441 243.72L58.9986 235.261L47.4241 233.978Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4241 233.978L42.9043 253.493H72.2833L57.0441 243.72L58.9986 235.261L47.4241 233.978Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1185 252.363L46.0198 238.528C46.1114 238.07 46.5695 237.734 47.0276 237.795L60.2206 239.444C60.8009 239.505 61.1674 240.116 60.9536 240.666L59.9458 243.353C59.7931 243.781 59.9763 244.27 60.3733 244.483L74.1466 251.691C75.0017 252.149 74.6658 253.431 73.7191 253.431H44.0042C43.4545 253.493 42.9964 252.943 43.1185 252.363Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1185 252.363L46.0198 238.528C46.1114 238.07 46.5695 237.734 47.0276 237.795L60.2206 239.444C60.8009 239.505 61.1674 240.116 60.9536 240.666L59.9458 243.353C59.7931 243.781 59.9763 244.27 60.3733 244.483L74.1466 251.691C75.0017 252.149 74.6658 253.431 73.7191 253.431H44.0042C43.4545 253.493 42.9964 252.943 43.1185 252.363Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M133.637 183.19L129.087 202.675H159.016L143.257 192.933L145.212 184.473L133.637 183.19Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.637 183.19L129.087 202.675H159.016L143.257 192.933L145.212 184.473L133.637 183.19Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M129.331 201.575L132.232 187.741C132.323 187.283 132.781 186.947 133.24 187.008L146.433 188.657C147.013 188.718 147.379 189.329 147.166 189.879L146.158 192.566C146.005 192.994 146.188 193.483 146.585 193.696L160.359 200.904C161.214 201.362 160.878 202.644 159.931 202.644H130.216C129.636 202.675 129.208 202.156 129.331 201.575Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.331 201.575L132.232 187.741C132.323 187.283 132.781 186.947 133.24 187.008L146.433 188.657C147.013 188.718 147.379 189.329 147.166 189.879L146.158 192.566C146.005 192.994 146.188 193.483 146.585 193.696L160.359 200.904C161.214 201.362 160.878 202.644 159.931 202.644H130.216C129.636 202.675 129.208 202.156 129.331 201.575Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0059 43.9002C99.2503 46.0685 101.174 47.626 103.343 47.3817C103.617 47.3511 103.892 47.2901 104.167 47.1984L101.724 57.7956C101.724 57.7956 101.968 61.0023 106.61 62.2239C111.283 63.4454 114.642 61.552 114.428 57.7956C114.428 57.6429 114.215 55.5052 114.001 53.1842C114.092 53.1842 114.184 53.1842 114.276 53.1536C119.62 52.5734 123.499 47.7787 122.918 42.4037C122.674 40.2049 121.727 38.2198 120.292 36.7234C118.276 34.5856 115.314 33.3946 112.168 33.7305C108.504 34.1276 105.511 36.5096 104.198 39.7163C103.648 39.533 103.098 39.4414 102.487 39.5025C100.35 39.7774 98.7922 41.7319 99.0059 43.9002Z",
    fill: "#FFEEDF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0059 43.9002C99.2503 46.0685 101.174 47.626 103.343 47.3817C103.617 47.3511 103.892 47.2901 104.167 47.1984L101.724 57.7956C101.724 57.7956 101.968 61.0023 106.61 62.2239C111.283 63.4454 114.642 61.552 114.428 57.7956C114.428 57.6429 114.215 55.5052 114.001 53.1842C114.092 53.1842 114.184 53.1842 114.276 53.1536C119.62 52.5734 123.499 47.7787 122.918 42.4037C122.674 40.2049 121.727 38.2198 120.292 36.7234C118.276 34.5856 115.314 33.3946 112.168 33.7305C108.504 34.1276 105.511 36.5096 104.198 39.7163C103.648 39.533 103.098 39.4414 102.487 39.5025C100.35 39.7774 98.7922 41.7319 99.0059 43.9002Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53.1843C114 53.1843 111.923 53.2759 109.999 52.207C109.999 52.207 111.434 55.9328 114.275 56.1466L114 53.1843Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 53.1843C114 53.1843 111.923 53.2759 109.999 52.207C109.999 52.207 111.434 55.9328 114.275 56.1466L114 53.1843Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M104.228 39.747C104.441 39.8081 105.388 40.1746 105.907 41.1824C106.579 42.4956 105.999 43.7782 105.907 43.9309C106.671 44.1447 107.678 44.4807 108.87 43.7477C109.114 43.595 109.328 43.4118 109.511 43.2285L113.298 39.4111C118.886 40.2051 120.291 36.7542 120.291 36.7542C118.276 34.6164 115.313 33.4254 112.168 33.7613C108.534 34.1583 105.541 36.5709 104.228 39.747Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.228 39.747C104.441 39.8081 105.388 40.1746 105.907 41.1824C106.579 42.4956 105.999 43.7782 105.907 43.9309C106.671 44.1447 107.678 44.4807 108.87 43.7477C109.114 43.595 109.328 43.4118 109.511 43.2285L113.298 39.4111C118.886 40.2051 120.291 36.7542 120.291 36.7542C118.276 34.6164 115.313 33.4254 112.168 33.7613C108.534 34.1583 105.541 36.5709 104.228 39.747Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M242.205 203.56C242.205 210.004 236.983 215.226 230.539 215.226C224.095 215.226 218.873 210.004 218.873 203.56C218.873 197.116 224.095 191.894 230.539 191.894C236.983 191.894 242.205 197.116 242.205 203.56Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4524 28.2948C74.4524 31.7763 71.6427 34.5859 68.1612 34.5859C64.6797 34.5859 61.8701 31.7763 61.8701 28.2948C61.8701 24.8133 64.6797 22.0037 68.1612 22.0037C71.6427 21.9731 74.4524 24.8133 74.4524 28.2948Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9322 103.391C66.786 104.369 50.4168 98.7493 52.9516 86.106C55.4864 73.4626 75.5813 58.1318 89.4462 56.3911C100.44 55.0168 105.938 56.3911 105.938 56.3911C105.938 56.3911 120.199 55.8414 135.011 72.241C147.319 85.8922 150.128 100.093 150.128 100.093L173.46 79.3873C173.827 79.0513 174.407 79.0819 174.743 79.4789L184.21 90.1677C184.516 90.5036 184.516 91.0228 184.21 91.3587C180.668 95.5732 159.198 120.524 147.349 120.738C134.37 120.982 123.62 93.3743 123.62 93.3743L113.542 127.059L69.7483 123.028L73.9322 103.391Z",
    fill: "#D7FFEF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9322 103.391C66.786 104.369 50.4168 98.7493 52.9516 86.106C55.4864 73.4626 75.5813 58.1318 89.4462 56.3911C100.44 55.0168 105.938 56.3911 105.938 56.3911C105.938 56.3911 120.199 55.8414 135.011 72.241C147.319 85.8922 150.128 100.093 150.128 100.093L173.46 79.3873C173.827 79.0513 174.407 79.0819 174.743 79.4789L184.21 90.1677C184.516 90.5036 184.516 91.0228 184.21 91.3587C180.668 95.5732 159.198 120.524 147.349 120.738C134.37 120.982 123.62 93.3743 123.62 93.3743L113.542 127.059L69.7483 123.028L73.9322 103.391Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7491 123.028L43.1797 233.184C43.0576 233.733 43.424 234.253 44.0043 234.314L66.2676 236.238C66.6951 236.268 67.1227 235.993 67.2143 235.566L98.1813 125.899L69.7491 123.028Z",
    fill: "#003669"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7491 123.028L43.1797 233.184C43.0576 233.733 43.424 234.253 44.0043 234.314L66.2676 236.238C66.6951 236.268 67.1227 235.993 67.2143 235.566L98.1813 125.899L69.7491 123.028Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7656 131.762C75.7656 131.762 78.6057 152.865 101.144 149.353C123.682 145.841 140.601 143.459 140.601 143.459L129.087 182.58C128.904 183.16 129.332 183.741 129.943 183.741L150.068 184.565C150.435 184.565 150.77 184.382 150.923 184.046C153.519 178.579 174.316 133.625 162.284 123.028C151.717 113.714 79.5219 121.623 69.7188 123.028L75.7656 131.762Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7656 131.762C75.7656 131.762 78.6057 152.865 101.144 149.353C123.682 145.841 140.601 143.459 140.601 143.459L129.087 182.58C128.904 183.16 129.332 183.741 129.943 183.741L150.068 184.565C150.435 184.565 150.77 184.382 150.923 184.046C153.519 178.579 174.316 133.625 162.284 123.028C151.717 113.714 79.5219 121.623 69.7188 123.028L75.7656 131.762Z",
    fill: "#003669",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1992 106.903L77.9634 83.6318L73.1992 106.903Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1992 106.903L77.9634 83.6318",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8379 106.231L75.3682 96.3364L68.3136 128.983L65.0153 130.51L53.8379 106.231Z",
    fill: "#0E9C63"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8379 106.231L75.3682 96.3364L68.3136 128.983L65.0153 130.51L53.8379 106.231Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M193.586 253.492H108.351C107.832 253.492 107.435 253.095 107.435 252.576V203.591C107.435 203.072 107.832 202.675 108.351 202.675H193.586C194.106 202.675 194.503 203.072 194.503 203.591V252.576C194.503 253.065 194.106 253.492 193.586 253.492Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.586 253.492H108.351C107.832 253.492 107.435 253.095 107.435 252.576V203.591C107.435 203.072 107.832 202.675 108.351 202.675H193.586C194.106 202.675 194.503 203.072 194.503 203.591V252.576C194.503 253.065 194.106 253.492 193.586 253.492Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M144.601 253.492H108.351C107.832 253.492 107.435 253.095 107.435 252.576V203.591C107.435 203.072 107.832 202.675 108.351 202.675H144.601C145.12 202.675 145.517 203.072 145.517 203.591V252.576C145.517 253.065 145.09 253.492 144.601 253.492Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.601 253.492H108.351C107.832 253.492 107.435 253.095 107.435 252.576V203.591C107.435 203.072 107.832 202.675 108.351 202.675H144.601C145.12 202.675 145.517 203.072 145.517 203.591V252.576C145.517 253.065 145.09 253.492 144.601 253.492Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M180.699 86.1975L182.562 82.0747C182.562 82.0747 192.701 80.7921 193.739 76.1195C195.022 70.4086 195.022 66.0415 195.022 66.0415L186.44 74.6231L177.798 78.5932L175.904 80.7615L180.699 86.1975Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.699 86.1975L182.562 82.0747C182.562 82.0747 192.701 80.7921 193.739 76.1195C195.022 70.4086 195.022 66.0415 195.022 66.0415L186.44 74.6231L177.798 78.5932L175.904 80.7615L180.699 86.1975Z",
    stroke: "black",
    strokeWidth: 2.00636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundImg);
export default __webpack_public_path__ + "static/media/not-found-img.dfc461af8a5926a894ea5c34ca55a814.svg";
export { ForwardRef as ReactComponent };